import { createStore, applyMiddleware, compose } from 'redux';
import reducer from '../reducers/RootReducer';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import {initSagas} from './initSagas';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(reducer,compose(
    applyMiddleware(sagaMiddleware),
    applyMiddleware(thunk)
));
initSagas(sagaMiddleware);

export default store;
